<template>
  <div class="wrapper sub-page">
    <div class="container container-fluid pt-0 px-0 py-1 content-main-container">
      <div class="main-content container">
        <header class="header-block" style="height: 0;"></header>
        <swiper v-bind="swiperOptions"
          class="banner-block swiper swiper-index-default swiper-container-initialized swiper-container-horizontal">
          <swiper-slide class="banner-block-wrapper swiper-wrapper">
            <a href="#" class="banner-item swiper-slide" data-swiper-slide-index="2" role="group" aria-label="1 / 5">
              <img class="pic" src="/static/img/banner/banner1.png" alt="" />
            </a>
          </swiper-slide>
          <swiper-slide class="banner-block-wrapper swiper-wrapper">
            <a href="#" class="banner-item swiper-slide" data-swiper-slide-index="2" role="group" aria-label="2 / 5">
              <img class="pic" src="/static/img/banner/banner2.png" alt="" />
            </a>
          </swiper-slide>
          <swiper-slide class="banner-block-wrapper swiper-wrapper">
            <a href="#" class="banner-item swiper-slide" data-swiper-slide-index="2" role="group" aria-label="3 / 5">
              <img class="pic" src="/static/img/banner/banner3.png" alt="" />
            </a>
          </swiper-slide>
        </swiper>
        <div class="game-type-block">
          <a href="#" class="game-type-item">
            <img src="/static/img/icon/slot_red.svg" alt="" class="ic" />
            <span class="name">สล็อต</span>
          </a>

          <a href="#" class="game-type-item">
            <img src="/static/img/icon/diamond_black.svg" alt="" class="ic" />
            <span class="name">บาคาร่า</span>
          </a>

          <a href="#" class="game-type-item">
            <img src="/static/img/icon/poker_red.svg" alt="" class="ic" />
            <span class="name">โป๊กเกอร์</span>
          </a>

          <a href="#" class="game-type-item">
            <img src="/static/img/icon/trade_red.svg" alt="" class="ic" />
            <span class="name">ลงทุน</span>
          </a>

          <router-link to="/register" class="game-type-item jackpot">
            <span class="name">สมัครสมาชิก</span>
            <div class="bottom">
              <img src="/static/img/icon/jackpot_red.svg" alt="" class="ic" />
              <span class="amount">รับสิทธิพิเศษ</span>
            </div>
          </router-link>
        </div>
        <div class="game-list-block">
          <div class="game-list-header">
            <div class="action-panel">
              <button class="_btn-reset" type="button">
                เกมส์มากมายอัตราการจ่ายสูง
              </button>
            </div>
            <div class="title">คัดรวมค่ายดังมากกว่า 30 ค่ายเกมส์</div>
          </div>
          <nav>
            <div id="nav-tab-games-show" class="nav nav-tabs" role="tablist">
              <a id="nav-games-rec-tab" class="nav-link " :class="{ 'active': tab == 1 }" @click="tab = 1">เกมส์สล็อต</a>
              <a id="nav-games-hit-tab" class="nav-link" :class="{ 'active': tab == 2 }"
                @click="tab = 2">เกมส์โป๊กเกอร์</a>
              <a id="nav-games-new-tab" class="nav-link" :class="{ 'active': tab == 3 }" @click="tab = 3"
                v-if="getGameList.ImagePOKER.length > 0">เกมส์คาสิโน</a>
              <a id="nav-games-new-tab" class="nav-link" :class="{ 'active': tab == 4 }" @click="tab = 4"
                v-if="getGameList.ImageTRADING.length > 0">ลงทุน</a>
            </div>
          </nav>
          <div id="nav-tabContent" class="tab-content">
            <div id="nav-games-rec" class="tab-pane fade " v-if="tab == 1" :class="{ 'show active': tab == 1 }">
              <div class="grid list">
                <div class="grid-sizer">&nbsp;</div>
                <div class="grid-item " v-for="(item, i) in getGameList.ImageSlot" :key="i"
                  :class="{ 'grid-item--width2': i + (1 % 6) == 0 }">
                  <img class="pic" :src="item.img" alt="" />
                </div>
              </div>
            </div>
            <div id="nav-games-hit" class="tab-pane fade " v-if="tab == 2" :class="{ 'show active': tab == 2 }">
              <div class="grid list center">
                <div class="grid-sizer">&nbsp;</div>
                <div class="grid-item " v-for="(item, i) in getGameList.ImageCasino" :key="i"
                  :class="{ 'grid-item--width2': i + (1 % 6) == 0 }">
                  <img class="pic" :src="item.img" alt="" />
                </div>
              </div>
            </div>
            <div id="nav-games-new" class="tab-pane fade" v-if="tab == 3" :class="{ 'show active': tab == 3 }">
              <div class="grid list center">
                <div class="grid-sizer">&nbsp;</div>
                <div class="grid-item " v-for="(item, i) in getGameList.ImagePOKER" :key="i"
                  :class="{ 'grid-item--width2': i + (1 % 6) == 0 }">
                  <img class="pic" :src="item.img" alt="" />
                </div>
              </div>
            </div>
            <div id="nav-games-new" class="tab-pane fade" v-if="tab == 4" :class="{ 'show active': tab == 4 }">
              <div class="grid list center">
                <div class="grid-sizer">&nbsp;</div>
                <div class="grid-item " v-for="(item, i) in getGameList.ImageTRADING" :key="i"
                  :class="{ 'grid-item--width2': i + (1 % 6) == 0 }">
                  <img class="pic" :src="item.img" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="why-us-block">
          <h2 class="title">ทำไมต้องเล่นเว็บเรา</h2>
          <div class="why-us-list list">
            <div class="why-us-item-sizer">&nbsp;</div>
            <div class="why-us-item why-us-item--height3">
              <div class="why-us-item-inner">
                <img class="pic-head" src="/static/img/why_us/1.png" alt="" />
                <h3 class="title">
                  เว็บตรงคงกระพัน เปิดมายาวนาน มั่นใจได้ ไม่มีบล็อกยูส
                  ผู้เล่นจำนวนมาก
                </h3>
                <p class="para">
                  ลิขสิทธิแท้จากต่างประเทศ ผู้เล่นจำนวนมาก มั่นคง ฝากน้อยถอนเยอะ
                  อัพเดทค่ายดังทุกเดือน
                </p>
              </div>
            </div>
            <div class="why-us-item">
              <div class="why-us-item-inner center-xy">
                <h3 class="title center">
                  สล็อตแตกง่าย ค่ายจำนวนมาก เติมหลักร้อย แตกเงินแสน
                </h3>
              </div>
            </div>
            <div class="why-us-item">
              <div class="why-us-item-inner center-xy">
                <h3 class="title center">
                  ฝากถอนผ่านระบบออโต้ ไม่ต้องรอพนักงานตรวจสอบ
                </h3>
              </div>
            </div>
            <div class="why-us-item why-us-item--width2 why-us-item--height2">
              <div class="why-us-item-inner">
                <img class="pic-head" src="/static/img/why_us/2.png" alt="" />
                <h3 class="title">Best Baccarat Provider</h3>
                <p class="para">
                  ค่ายเกมส์บาคาร่าชั้นนำจากต่างประเทศอัตราการจ่ายสูงเป็นมาตรฐาน
                  เงินตอบแทนคุ้มค่า ไม่จำกัดการถอน ในทุกรูปแบบ 10
                  ไม้ติดต่อกันก็จ่าย ไม่อั้น
                </p>
              </div>
            </div>
            <div class="why-us-item why-us-item--width2 why-us-item--height2">
              <div class="why-us-item-inner">
                <img class="pic-head" src="/static/img/why_us/3.png" alt="" />
                <h3 class="title">เว็บเดิมพันอันดับหนึ่ง</h3>
                <p class="para">
                  สมัครเว็บพนันออนไลน์ แนะนำ เว็บตรงไม่ผ่านเอเย่นต์ ไม่มีขั้นต่ำ
                  2022 เว็บพนันออนไลน์ ที่ดีที่สุดสมัครเว็บตรงไม่ผ่านเอเย่นต์
                  โปรโมชั่นสำหรับสมาชิกใหม่ระบบเติมเงินอัตโนมัติ รวดเร็ว
                </p>
              </div>
            </div>
            <div class="why-us-item">
              <div class="why-us-item-inner center-xy">
                <h3 class="title center">
                  เว็บเดิมพันออนไลน์อันดับหนึ่ง เว็บตรงอัตราจ่ายสูง ไม่โกง
                </h3>
              </div>
            </div>
            <div class="why-us-item">
              <div class="why-us-item-inner center-xy">
                <h3 class="title center">
                  สล็อตแตกง่าย ค่ายจำนวนมาก เติมหลักร้อย แตกเงินแสน
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="provider-logo-block">
          <h2 class="title">ค่ายเกมส์ชั้นนำ</h2>
          <ul class="list">
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/1.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/2.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/3.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/4.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/5.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/6.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/7.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/8.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/9.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/10.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/11.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/12.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/13.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/14.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/15.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/16.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/17.png" alt="" />
            </li>
            <li class="provider-logo-item">
              <img class="pic" src="/static/img/providers_logo/18.png" alt="" />
            </li>
          </ul>
        </div>
        <footer class="footer-block">
          <div class="footer-top">
            <div class="left">
              <img class="footer-logo-web" src="/static/img/logo/logo-social789.png" width="100%" height="100%" />
              <p class="footer-paragraph">
                เว็บไซต์ผู้ให้บริการเกมเดิมพันออนไลน์มากมายต่างๆนาๆทุกรูปแบบมากกว่า
                13 ค่ายคาสิโน แนวหน้าทั่วโลก เป๋าเดียวจบไม่ต้องโยกเงิน
                ฝาก-ถอนด้วยตัวเองผ่านระบบอัตโนมัติ ถอนไม่อั้น 1 วินาทีทันที.
              </p>
              <p class="footer-paragraph">
                ร่วมเข้ามาเล่น คาสิโนออนไลน์
                กันเต็มเปี่ยมกับความเพลิดเพลินใจได้ตลอดเวลา 24 ชั่วโมง
                ได้ทั้งมือถือหรือว่าอุปกรณ์ที่เชื่อมต่ออินเตอร์เน็ตได้นั่นเอง
                พร้อมมีทีมงานคอยให้คำปรึกษาแก้ปัญหาทุกกฎเกณฑ์ของ เกมคาสิโน
                บนโลกใบนี้ สมัครเข้าเล่นได้ง่ายดายไม่กี่ขั้นตอน
                พร้อมรับสิทธิพิเศษที่จะตามมานับไม่ถ้วน..
              </p>
              <div class="footer-bank-list">
                <img class="ic" src="/static/img/bank/1.svg" alt="" />
                <img class="ic" src="/static/img/bank/2.svg" alt="" />
                <img class="ic" src="/static/img/bank/3.svg" alt="" />
                <img class="ic" src="/static/img/bank/4.svg" alt="" />
                <img class="ic" src="/static/img/bank/5.svg" alt="" />
                <img class="ic" src="/static/img/bank/6.svg" alt="" />
                <img class="ic" src="/static/img/bank/7.svg" alt="" />
                <img class="ic" src="/static/img/bank/8.svg" alt="" />
              </div>
            </div>
            <div class="right">
              <div class="footer-express-link">
                <a class="link" href="/">หน้าแรก</a>
                <a class="link" v-bind:href="`https://line.me/R/ti/p/${getLineId}`">ติดต่อ</a>
              </div>
              <div class="footer-device">
                <div class="android footer-device-item">
                  <img class="ic" src="/static/img/device/1.svg" alt="" />&nbsp;Android
                </div>
                <div class="ios footer-device-item">
                  <img class="ic" src="/static/img/device/2.svg" alt="" />&nbsp;IOS
                </div>
                <div class="windows footer-device-item">
                  <img class="ic" src="/static/img/device/3.svg" alt="" />&nbsp;MacOS
                </div>
                <div class="macos footer-device-item">
                  <img class="ic" src="/static/img/device/4.svg" alt="" />&nbsp;Windows
                </div>
              </div>
              <div class="footer-social">
                <a class="footer-social-item">
                  <img class="ic" src="/static/img/social/line.svg" alt="" />
                </a>
                <a class="footer-social-item">
                  <img class="ic" src="/static/img/social/facebook.svg" alt="" />
                </a>
                <a class="footer-social-item">
                  <img class="ic" src="/static/img/social/instagram.svg" alt="" />
                </a>
                <a class="footer-social-item">
                  <img class="ic" src="/static/img/social/youtube.svg" alt="" />
                </a>
              </div>
            </div>
          </div>
          <div class="bottom">
            Galaxy56.com Copyright ©2022 . All rights reserved.
          </div>
        </footer>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getPrefix } from "@/services/modules/global.js";
import { reward } from "@/config/reward.js";
import carousel from "vue-owl-carousel";
import LoginForm from "@/components/form/LoginForm";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

import RegisterForm from "@/components/form/RegisterForm";
import VueSlickCarousel from "vue-slick-carousel";
// import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import carousel from "vue-owl-carousel";

import { Navigation, Pagination, Autoplay } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
// import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation, Pagination, Autoplay]);

import api from "@/services/index.js";

export default {
  name: "Index",
  data() {
    return {
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
      showHeader: false,
      gameTab: 0,
      swiperOptions: {
        loop: true,
        slidesPerView: 1,
        navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
        calculateHeight: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      },
      availableBalance: "Loading...",
      availableCredit: "Loading...",
      isShowGame: true,
      chList: [],
      gameList: [],
      inGameList: false,
      ischName: "บริการของเรา",
      havelink: 0,
      gameListChunk: [],
      gameType: true,
      gameCH: this.$route.params.ch,
      chSlotList: [],
      gameCH: undefined,
      gameImg: "",
      gameType: "",
      gameCategory: "",
      productId: "",
      category:
        this.$route.params.category == undefined
          ? "Casino"
          : this.$route.params.category,
      tab: 1,
    };
  },
  components: {
    Header,
    Swiper,
    SwiperSlide,
    Footer,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "appTitle",
    ]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    gotoRoute(route) {
      this.$router.push(route);
    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    gotoCategory(category) {
      this.inGameList = false;
      this.category = category;
      this.$router.push(`/play/${category}`).catch(() => { });
    },

    gotoSub(route, item) {
      (this.gameImg = item.img
        .replace("game", "game_tranparent")
        .replace("game_betflik", "game_betflik_tranparent")),
        (this.gameType = item.gameType),
        (this.gameCategory = item.gameCategory),
        this.getGames(item.ch, item.gameType, item.category);
    },
    // async getChannels() {
    //   console.log("getChannels");

    //   await api
    //     .get("/user-profile-composite/v1/products")
    //     .then((v) => {
    //       if (v.success == true) {
    //         this.chList = v.data;
    //       } else {
    //         this.$swal.fire("แจ้งเตือน", v.message, "error");
    //       }
    //     })
    //     .catch((e) => {
    //       this.$swal.fire("แจ้งเตือน", e.message, "error");
    //     })
    //     .finally(() => {});
    // },
    async LoginGame(gameCode) {
      setTimeout(async () => {
        await api
          .get(`/user-profile-composite/v1/logIn/${this.productId}/${gameCode}`)
          .then((v) => {
            if (v.success == true) {
              if(v.data.url){
                setTimeout("location.href = '" + v.data.url + "';", 100);
              }else{
                this.$swal.fire("ไม่พบตัวเกม กรุณาลองใหม่อีกครั้ง", "", "error");
              }
            } else {
              this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            this.$swal.fire("แจ้งเตือน", e.message, "error");
          })
          .finally(() => { });
      }, 3000);
    },
    async getGames(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }
        console.log("NO LOBBY");
        console.log(filter);
        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => { });
      }
    },

    async getGamesPage(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }

        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              this.$router
                .replace(`/play/${this.category}/${filter}/${chId}`)
                .catch(() => { });
              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => { });
        // this.$router.push({ name: 'play', params: { category: this.category } });
        // this.$router.replace(`/play/${this.category}/${filter}/${chId}`).catch(() => { });
      }
    },
  },
  async mounted() {
    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }

    // await this.getChannels();

    if (this.$route.params.category != undefined) {
      this.category = this.$route.params.category;
      console.log(this.$route.params.category);

      if (
        this.$route.params.ch == undefined &&
        this.$route.params.gameType == undefined
      ) {
        console.log("chchch");
      } else {
        this.category = this.$route.params.category;
        this.inGameList = true;
        console.log("gameTypegameTypegameType");
        console.log(this.$route.params.gameType);
        console.log(this.$route.params.ch);
        this.getGames(
          this.$route.params.ch,
          this.$route.params.gameType,
          this.$route.params.category
        );
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/views/Index.vue